import { ProductGroupMultiselectFilter, SideFilters } from '@retail/components';
import { ExcludeVatSwitch } from '@retail/my-assortment/components';
import { useAppTFunction } from '@retail/app/i18n';
import {
  MgSupplierItemSearchField,
  SelectSuppliersAutocomplete,
} from '@retail/products/components';
import { FilterOptions, ProductGroup } from '@retail/products/types';
import { searchFilters, SearchFilters } from '@retail/products/utils';
import { useFilters } from '@retail/products/hooks';

interface Props {
  includeVat: boolean;
  showFilters: boolean;
  filterOptions: FilterOptions;
  toggleIncludeVat: () => void;
}

export function AddItemsFilters({
  includeVat,
  showFilters,
  filterOptions,
  toggleIncludeVat,
}: Props) {
  const t = useAppTFunction();
  const { filters, setFilters, updateFilter } = useFilters<SearchFilters>(searchFilters);

  return (
    <SideFilters heading={t('calculus.filter')} showFilters={showFilters} sx={{ height: '100%' }}>
      <ExcludeVatSwitch
        toggleVat={includeVat}
        handleToggleVat={toggleIncludeVat}
        label={t('campaign.filters.priceSuggestionsIncVat')}
      />
      <SelectSuppliersAutocomplete
        suppliers={filterOptions.suppliers}
        selectedSupplierNumbers={filters.supplierNumbers.map(Number)}
        isFetching={false}
        selectSuppliers={(supplierNumbers: number[]) =>
          setFilters({ supplierNumbers: supplierNumbers.map(String) })
        }
      />
      <MgSupplierItemSearchField
        searchTerm={filters.searchQuery ?? undefined}
        isDisabled={false}
        size="small"
        onSubmitSearch={(query?: string) => setFilters({ searchQuery: query })}
      />
      <ProductGroupMultiselectFilter
        productGroups={filterOptions.productGroupHierarchy}
        selectedProductGroups={filters.productGroupNumbers ?? []}
        selectProductGroup={(groupNumber: string) =>
          updateFilter('productGroupNumbers', groupNumber)
        }
        getCount={(productGroup: ProductGroup) => productGroup.count}
      />
    </SideFilters>
  );
}
